const dollars = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/** Formats a price in cents as a bare dollar amount, e.g. `12.5`. */
export const formatDollarAmount = (cents: number) => dollars.format(cents / 100);

/** Formats a price in cents as dollars, e.g. `$12.5`. */
export const formatDollars = (cents: number) => `$${formatDollarAmount(cents)}`;
